import { useState, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Menu, X } from 'lucide-react'
import Button from '../shared/Button'

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false)
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
  const location = useLocation()

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10)
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  useEffect(() => {
    setIsMobileMenuOpen(false)
  }, [location])

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Services', path: '/services' },
    { name: 'Blog', path: '/blog' },
    { name: 'Contact', path: '/contact' }
  ]

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-dark-900/95 backdrop-blur-xl border-b border-neon-lime/20' : 'bg-dark-900'
      }`}
    >
      <nav className="container-custom py-5">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="text-2xl text-neutral-100 tracking-tight hover:text-neon-lime transition-colors">
            <span className="text-neon-lime">/mathos</span> consult
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-base font-medium transition-colors hover:text-neon-lime ${
                  location.pathname === link.path
                    ? 'text-neon-lime'
                    : 'text-neutral-300'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <Link to="/contact#booking">
              <Button variant="outline" size="small">Book Discovery Call</Button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2 text-neutral-100 hover:text-neon-lime transition-colors"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <div className="md:hidden absolute left-0 right-0 top-full bg-dark-800 shadow-soft-lg border-t border-neon-lime/20">
            <div className="container-custom py-4 flex flex-col gap-4">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`text-lg font-medium py-2 transition-colors hover:text-neon-lime ${
                    location.pathname === link.path
                      ? 'text-neon-lime'
                      : 'text-neutral-300'
                  }`}
                >
                  {link.name}
                </Link>
              ))}
              <Link to="/contact#booking">
                <Button variant="outline" className="w-full" size="small">
                  Book Discovery Call
                </Button>
              </Link>
            </div>
          </div>
        )}
      </nav>
    </header>
  )
}
